module.exports = __webpack_public_path__ + "static/media/1.3ef35ac8.jpg";